// extracted by mini-css-extract-plugin
export default {"dependency-graph-container":"DependencyGraphDialog_dependency-graph-container__8p2G-","dependencyGraphContainer":"DependencyGraphDialog_dependency-graph-container__8p2G-"};